export default {

    showModalApp: (ele) => {
        jQuery('#'+ele).modal('show')
    },

    closeModalApp: (ele) => {
        jQuery('#'+ele).trigger('click.dismiss.bs.modal')
    }
}